<div class="flex flex-wrap justify-between">
  <div class="pb-4 info-message">
    <mnc-documents-shared-info-message [title]="'Download A&G Notes Report'">
      <p class="info-text">
        {{ infoMessage }}
      </p>
    </mnc-documents-shared-info-message>
  </div>
  <div class="pb-4">
    <button
      severity="secondary"
      class="mr-2"
      icon="pi pi-filter-slash"
      label="Clear All Filters"
      pButton
      (click)="clearFilters()"
      >
    </button>
    <button pButton [disabled]="selectedLines.length === 0 || isLoading" (click)="downloadNotes()">
      <i class="pi pi-download pr-2"></i>
      Download Notes
    </button>
  </div>
</div>

@if (isLoading) {
  <p-progressSpinner></p-progressSpinner>
}

<div [hidden]="isLoading">
  @if (platformService.widgetContext === dmepos) {
    <mnc-product-cases-lines-selection #streamLineSelector
      [cases]="lineData"
      (casesLinesSelected)="handleLinesSelected($event)"
      />
    }
    <!-- TODO: Remove PAC Commercial after LOB migration -->
    @if (platformService.widgetContext === pacIM || platformService.widgetContext === pacCom) {
      <mnc-service-lines-selection #streamLineSelector
        [lines]="lineData"
        (serviceLinesSelected)="handleLinesSelected($event)"
        />
      }

      @if (platformService.widgetContext === hh) {
        <mnc-service-lines-table #streamLineSelector
          [lines]="lineData"
          (serviceLinesSelected)="handleLinesSelected($event)"
          />
        }
      </div>
